import { useState } from "react";
import { RouteTypes } from "hooks/utils/util";
import PageHeader from "../-components/PageHeader";
import NoticesForm, { NoticeFormProps } from "./NoticeForm";
import Seo from "components/Seo";

export default function ConsoleNoticeCreate({ type }: { type: RouteTypes }) {
    const initialSearchForm = {
        category: type,
        name: "관리자",
        subject: "",
        contents: "",
        notice: 0,
        b_file: "",
        list_no: null,
    };
    const [form, setForm] = useState<NoticeFormProps>(initialSearchForm);

    return (
        <>
            <Seo type="console" pageTitle="공지사항" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="사이트관리" title="공지사항" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className=" px-[40px] py-[28px] w-full overflow-auto">
                        <div className="bg-white rounded-[20px] py-[36px] px-[40px] min-w-[800px]">
                            <NoticesForm type={type} form={form} setForm={setForm} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
